import styled from 'styled-components'

export default styled.div`
  width: 700px;
  height: 95%;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;

  .modal-title {
    font-size: 20px;
  }

  .towns {
    overflow: auto;
  }

  .row {
    position: relative;
    min-height: 50px;
    cursor: pointer;
    overflow-x: hidden;
    -webkit-flex: 0
    -ms-flex: 0;
    flex: 0;
    display: inline;

    & img.check {
      position: absolute;
      right: 0;
      width: 30px;
      height: 30px;
    }

    & li {
      border-bottom: 1px solid ${ ({ theme }) => theme.colors.greyLight };
      padding: 0 20px;
    }

    &:hover {
      background-color: #F3F3F3;
    }

    &:first-child {
      & li {
        border-top: 1px solid ${ ({ theme }) => theme.colors.greyLight };
      }
    }
  }
  
  @media screen and (max-width: 768px) {
    width: 90%;
    position: relative;
  }
`
